import api from "@/configs/axios-config";

export type MaterialType = {
  id: number;
  material_type_name: string;
  description: string;
  is_active: boolean;
  created_at: string;
  created_by: string;
  updated_at: string;
  updated_by: string;
  specs_count: number;
};

export type getMaterialTypeParams = {
  skip?: number;
  limit?: number;
  search?: string;
  active_only?: boolean;
};

export const getAllMaterialTypes = async (
  params: getMaterialTypeParams,
): Promise<MaterialType[]> => {
  params = {
    skip: params.skip ?? 0,
    limit: params.limit ?? 1000,
    active_only: true,
    ...params,
  };
  const response = await api.get("/material-types/", { params });
  const data = response.data?.data;
  return data.sort((a: MaterialType, b: MaterialType) =>
    a.material_type_name.localeCompare(b.material_type_name),
  );
};

export type MaterialTypeSpec = {
  id: number;
  spec_name: string;
  material_type_id: number;
  material_type_name: string;
  description: string;
  is_active: boolean;
  created_at: string;
  created_by: string;
  updated_at: string;
  updated_by: string;
};

export const getSpecsByMaterialTypeId = async (
  materialTypeId: number,
  params: getMaterialTypeParams,
) => {
  params = {
    skip: params.skip ?? 0,
    limit: params.limit ?? 1000,
    active_only: false,
    ...params,
  };
  const response = await api.get(`/material-types/${materialTypeId}/specs`, {
    params,
  });
  const data = response.data?.data;

  return data.sort((a: MaterialTypeSpec, b: MaterialTypeSpec) => {
    if (a.is_active === b.is_active) {
      return a.spec_name.localeCompare(b.spec_name);
    }
    return a.is_active ? -1 : 1;
  });
};

export type CreateMaterialType = {
  material_type_name: string;
  description?: string;
  is_active: boolean;
};

export const createMaterialType = async (data: CreateMaterialType) => {
  const response = await api.post("/material-types/", data);
  return response.data;
};

export const updateMaterialType = async (
  materialTypeId: number,
  data: CreateMaterialType,
) => {
  const response = await api.put(`/material-types/${materialTypeId}`, data);
  return response.data;
};

export type CreateSpecType = {
  spec_name: string;
  material_type_id?: number;
  is_active: boolean;
  description?: string;
};

export const createSpec = async (data: CreateSpecType) => {
  const response = await api.post("/material-types/specs", data);
  return response.data;
};

export const updateSpec = async (specId: number, data: CreateSpecType) => {
  const response = await api.put(`/material-types/specs/${specId}`, data);
  return response.data;
};

export const getAllSpecs = async (): Promise<MaterialTypeSpec[]> => {
  const response = await api.get("/material-types/specs/all", {
    params: { limit: 1000, active_only: true },
  });
  const data = response.data?.data;
  return data;
};
